<template>
    <v-app id="inspire">
        <v-form
            ref="form"
            action="/agencies"
            method="post"
        >
            <input name="_token" v-model="form.token" type="hidden">
                <div class="row">
                    <div class="col-12 col-sm-6 col-lg-6">
                        <v-text-field
                            v-model="form.name"
                            :rules="nameRules"
                            :counter="50"
                            :label="$options.filters.translate('vue.agency-name')"
                            required
                            prepend-icon="perm_identity"
                        ></v-text-field>
                        <input type="hidden" name="name" v-model="form.name">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-6">
                        <v-text-field
                            v-model="form.business_name"
                            :rules="businessNameRules"
                            :counter="50"
                            :label="$options.filters.translate('vue.businessname')"
                            required
                            prepend-icon="work"
                        ></v-text-field>
                        <input type="hidden" name="business_name" v-model="form.business_name">
                    </div>
                    <div class="col-12">
                        <v-text-field
                            v-model="form.surname"
                            :rules="surnameRules"
                            required
                            prepend-icon="verified_user"
                        >
                        <template v-slot:label>
                            <span v-html="$options.filters.translate('vue.agency-complete-name')"></span>
                        </template>
                        </v-text-field>
                        <input type="hidden" name="surname" v-model="form.surname">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-5">
                        <v-select
                            :items="type_documents"
                            :label="$options.filters.translate('vue.select_document')"
                            v-model="form.document_type"
                            :rules="typeRules"
                            item-text="name"
                            item-value="value"
                            required
                            prepend-icon="recent_actors"
                            class="documents"
                            attach=".documents"
                        ></v-select>
                        <input type="hidden" name="document_type" v-model="form.document_type">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-7">
                        <v-text-field
                            v-model="form.nif"
                            :label="$options.filters.translate('vue.nif')"
                            :rules="nifRules"
                            required
                            prepend-icon="recent_actors"
                        ></v-text-field>
                        <input type="hidden" name="nif" v-model="form.nif">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-8">
                        <v-text-field
                            v-model="form.address"
                            :label="$options.filters.translate('vue.agency-address')"
                            :rules="addressRules"
                            required
                            prepend-icon="location_city"
                        ></v-text-field>
                        <input type="hidden" name="address" v-model="form.address">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <v-text-field
                            v-model="form.cp"
                            :label="$options.filters.translate('vue.cp')"
                            :rules="codeRules"
                            required
                            prepend-icon="domain"
                        ></v-text-field>
                        <input type="hidden" name="cp" v-model="form.cp">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <v-text-field
                            v-model="form.city"
                            :label="$options.filters.translate('vue.agency-town')"
                            :rules="locationRules"
                            required
                            prepend-icon="location_city"
                        ></v-text-field>
                        <input type="hidden" name="city" v-model="form.city">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <v-select
                            :items="all_countries"
                            :label="$options.filters.translate('vue.country')"
                            v-model="form.country"
                            :rules="countryRules"
                            required
                            item-text="name"
                            item-value="value"
                            prepend-icon="public"
                            class="documents"
                            attach=".documents"
                        ></v-select>
                        <input type="hidden" name="country" v-model="form.country">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <v-text-field
                            v-model="form.region"
                            :label="$options.filters.translate('vue.region')"
                            :rules="regionRules"
                            required
                            prepend-icon="public"
                        ></v-text-field>
                        <input type="hidden" name="region" v-model="form.region">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <v-text-field
                            v-model="form.web"
                            :rules="webRules"
                            :counter="50"
                            :label="$options.filters.translate('vue.web')"
                            required
                            prepend-icon="computer"
                        ></v-text-field>
                        <input type="hidden" name="web" v-model="form.web">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-8">
                        <v-text-field
                            v-model="form.contact_person"
                            :rules="contactPersonRules"
                            :counter="50"
                            :label="$options.filters.translate('vue.contact_person')"
                            required
                            prepend-icon="contact_phone"
                        ></v-text-field>
                        <input type="hidden" name="contact_person" v-model="form.contact_person">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-6">
                        <v-text-field
                            v-model="form.email"
                            :rules="mailRules"
                            :counter="50"
                            :label="$options.filters.translate('vue.email')"
                            required
                            prepend-icon="email"
                        ></v-text-field>
                        <input type="hidden" name="email" v-model="form.email">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-6">
                        <v-text-field
                            v-model="form.email_confirmation"
                            :rules="repeatMailRules"
                            :counter="50"
                            :label="$options.filters.translate('vue.repeat_email')"
                            required
                            prepend-icon="email"
                        ></v-text-field>
                        <input type="hidden" name="email_confirmation" v-model="form.email_confirmation">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-6">
                        <v-autocomplete
                            v-model="form.prefix"
                            :items="prefixes"
                            item-text="name"
                            item-value="value"
                            :label="$options.filters.translate('vue.country_code')"
                            prepend-icon="flag"
                            class="prefix"
                            attach=".prefix"
                        ></v-autocomplete>
                        <input type="hidden" name="prefix" v-model="form.prefix">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-6">
                        <v-text-field
                            v-model="form.phone"
                            :rules="phoneRules"
                            :counter="15"
                            :label="$options.filters.translate('vue.phone')"
                            required
                            prepend-icon="phone"
                        ></v-text-field>
                        <input type="hidden" name="phone" v-model="form.phone">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-6">
                        <v-text-field
                            v-model="form.password"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="passwordRules"
                            :type="show1 ? 'text' : 'password'"
                            :label="$options.filters.translate('vue.password')"
                            hint="At least 8 characters"
                            prepend-icon="https"
                            counter
                            @click:append="show1 = !show1"
                        ></v-text-field>
                        <input type="hidden" name="password" v-model="form.password">
                    </div>
                    <div class="col-12 col-sm-6 col-lg-6">
                        <v-text-field
                            v-model="form.password_confirmation"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="repeatPasswordRules"
                            :type="show1 ? 'text' : 'password'"
                            name="password_confirmation"
                            :label="$options.filters.translate('vue.confirm_password')"
                            hint="At least 8 characters"
                            prepend-icon="https"
                            counter
                            @click:append="show1 = !show1"
                        ></v-text-field>
                        <input type="hidden" name="password_confirmation" v-model="form.password_confirmation">
                    </div>
                    <div class="col-auto mx-auto">
                        <v-checkbox
                            v-model="form.gridCheck1"
                            :rules="checkRules"
                        >
                            <template v-slot:label>
                                <span class="text-dark">{{trans('vue.policy_1')}}</span>
                                &nbsp;
                                <a target="_blank" href="/terms" class="text-secondary">
                                    {{trans('vue.policy_2')}}
                                </a>
                                &nbsp;
                                <span class="text-dark">{{trans('vue.policy_3')}}</span>
                                &nbsp;
                                <a target="_blank" href="/politic" class="text-secondary">
                                    {{trans('vue.policy_4')}}
                                </a>
                            </template>
                        </v-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-auto mx-auto mt-2 mb-4">
                        <div class="g-recaptcha" :data-sitekey="recaptcha"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-10 col-sm-8 col-md-6 col-lg-5 col-xl-4 mx-auto">
                        <v-btn
                            class="btn-block btn-lg py-1"
                            @click="submit"
                            large
                            color="warning"
                            type="submit">
                            <i class="far fa-envelope mr-3"></i> {{trans('vue.send')}}
                        </v-btn>
                    </div>
                </div>
        </v-form>
    </v-app>
</template>

<script>
    export default {
        name: "AgencyForm",
        props: ['countries', 'recaptcha', 'documents'],
        methods: {
            submit: function (event) {
                this.panel = [...Array(this.paxs).keys()].map(_ => true);
                if (!this.$refs.form.validate())
                    event.preventDefault()
            },
            trans(value) {
                if (!value) return '';
                return _.get(window.i18n, value);
            }
        },
        filters: {
            translate: function (value) {
                if (!value) return '';
                return _.get(window.i18n, value);
            }
        },
        computed: {
            all_countries(){
                let countries= [];
                Object.keys(this.countries).map((key, index) =>{
                    countries[key]={};
                    countries[key]['name'] = this.countries[key];
                    countries[key]['value'] = key;
                });
                return Object.values(countries);
            },
            type_documents(){
                let documents= [];
                Object.keys(this.documents).map((key, index) =>{
                    documents[key]={};
                    documents[key]['name'] = this.documents[key];
                    documents[key]['value'] = key;
                });
                return Object.values(documents);
            }
        },
        data(){
            return {
                show1: false,
                form: {
                    token: window.axios.defaults.headers.common['X-CSRF-TOKEN'],
                    name: '',
                    business_name: '',
                    document_type: '',
                    nif: '',
                    surname: '',
                    address: '',
                    cp: '',
                    city: '',
                    country: '',
                    region: '',
                    web: '',
                    contact_person: '',
                    email: '',
                    prefix: '34',
                    phone: '',
                    password: '',
                    password_confirmation: '',
                    email_confirmation: '',
                    gridCheck1: false
                },
                nameRules: [
                    v => !!v || 'Name is required',
                    v => v && v.length <= 50 || 'Name must be less than 50 characters'
                ],
                businessNameRules: [
                    v => !!v || 'business Name is required',
                    v => v && v.length <= 50 || 'Name must be less than 50 characters'
                ],
                surnameRules: [
                    v => !!v || 'Surname is required',
                    v => v && v.length <= 50 || 'Surname must be less than 50 characters'
                ],
                webRules: [
                    v => !!v || 'Web is required',
                ],
                regionRules: [
                    v => !!v || 'Region is required'
                ],
                contactPersonRules: [
                        v => !!v || 'Contact Person is required',
                    v => v && v.length <= 50 || 'Contact Person must be less than 50 characters'
                ],
                checkRules: [
                    v => !!v || 'Check is required'
                ],
                phoneRules: [
                    v => !!v || 'Phone is required',
                    v => v && v.length <= 15 || 'Phone must be less than 15 characters'
                ],
                mailRules: [
                    v => v && v.length <= 50 || 'Email must be less than 50 characters'
                ],
                repeatMailRules: [
                    v => v && v == this.form.email || 'Email must be equals'
                ],
                nifRules: [
                    v => !!v || this.trans('vue.dni_required'),
                    v => v && v.length <= 15 || 'DNI must be less than 15 characters'
                ],
                typeRules: [
                    v => !!v || this.trans('vue.type_document_required'),
                ],
                addressRules: [
                    v => !!v || this.trans('vue.address_required'),
                ],
                codeRules: [
                    v => !!v || this.trans('vue.postal_code_required'),
                ],
                locationRules: [
                    v => !!v || this.trans('vue.location_required'),
                ],
                countryRules: [
                    v => !!v || this.trans('vue.country_required'),
                ],
                passwordRules: [
                    v => !!v || 'Password is required',
                    v => v && v.length <= 15 || 'Password must be less than 8 characters'
                ],
                repeatPasswordRules: [
                    v => v && v == this.form.password || 'Password must be equals'
                ],
                prefixes: [
                    {
                        name:'United Kingdom (+44)',
                        value:'44'
                    },
                    {
                        name: 'USA-Canadá (+1)',
                        value: '1'
                    },
                    {
                        name: 'Algeria (+213)',
                        value: '213'
                    },
                    {
                        name: 'Andorra (+376)',
                        value: '376'
                    },
                    {
                        name: 'Angola (+244)',
                        value: '244'
                    },
                    {
                        name: 'Anguilla (+1264)',
                        value: '1264'
                    },
                    {
                        name: 'Antigua & Barbuda (+1268)',
                        value: '1268'
                    },
                    {
                        name: 'Argentina (+54)',
                        value: '54'
                    },
                    {
                        name: 'Armenia (+374)',
                        value: '374'
                    },
                    {
                        name: 'Aruba (+297)',
                        value: '297'
                    },
                    {
                        name: 'Australia (+61)',
                        value: '61'
                    },
                    {
                        name: 'Austria (+43)',
                        value: '43'
                    },
                    {
                        name: 'Azerbaijan (+994)',
                        value: '994'
                    },
                    {
                        name: 'Bahamas (+1242)',
                        value: '1242'
                    },
                    {
                        name: 'Bahrain (+973)',
                        value: '973'
                    },
                    {
                        name: 'Bangladesh (+880)',
                        value: '880'
                    },
                    {
                        name: 'Barbados (+1246)',
                        value: '1246'
                    },
                    {
                        name: 'Belarus (+375)',
                        value: '375'
                    },
                    {
                        name: 'Belgium (+32)',
                        value: '32'
                    },
                    {
                        name: 'Belize (+501)',
                        value: '501'
                    },
                    {
                        name: 'Benin (+229)',
                        value: '229'
                    },
                    {
                        name: 'Bermuda (+1441)',
                        value: '1441'
                    },
                    {
                        name: 'Bhutan (+975)',
                        value: '975'
                    },
                    {
                        name: 'Bolivia (+591)',
                        value: '591'
                    },
                    {
                        name: 'Bosnia Herzegovina (+387)',
                        value: '387'
                    },
                    {
                        name: 'Botswana (+267)',
                        value: '267'
                    },
                    {
                        name: 'Brazil (+55)',
                        value: '55'
                    },
                    {
                        name: 'Brunei (+673)',
                        value: '673'
                    },
                    {
                        name: 'Bulgaria (+359)',
                        value: '359'
                    },
                    {
                        name: 'Burkina Faso (+226)',
                        value: '226'
                    },
                    {
                        name: 'Burundi (+257)',
                        value: '257'
                    },
                    {
                        name: 'Cambodia (+855)',
                        value: '855'
                    },
                    {
                        name: 'Cameroon (+237)',
                        value: '237'
                    },
                    {
                        name: 'Cape Verde Islands (+238)',
                        value: '238'
                    },
                    {
                        name: 'Cayman Islands (+1345)',
                        value: '1345'
                    },
                    {
                        name: 'Central African Republic (+236)',
                        value: '236'
                    },
                    {
                        name: 'Chile (+56)',
                        value: '56'
                    },
                    {
                        name: 'China (+86)',
                        value: '86'
                    },
                    {
                        name: 'Colombia (+57)',
                        value: '57'
                    },
                    {
                        name: 'Comoros (+269)',
                        value: '269'
                    },
                    {
                        name: 'Congo (+242)',
                        value: '242'
                    },
                    {
                        name: 'Cook Islands (+682)',
                        value: '682'
                    },
                    {
                        name: 'Costa Rica (+506)',
                        value: '506'
                    },
                    {
                        name: 'Croatia (+385)',
                        value: '385'
                    },
                    {
                        name: 'Cuba (+53)',
                        value: '53'
                    },
                    {
                        name: 'Cyprus North (+90392)',
                        value: '90392'
                    },
                    {
                        name: 'Cyprus South (+357)',
                        value: '357'
                    },
                    {
                        name: 'Czech Republic (+42)',
                        value: '42'
                    },
                    {
                        name: 'Denmark (+45)',
                        value: '45'
                    },
                    {
                        name: 'Djibouti (+253)',
                        value: '253'
                    },
                    {
                        name: 'Dominica (+1809)',
                        value: '1809'
                    },
                    {
                        name: 'Dominican Republic (+1809)',
                        value: '1809'
                    },
                    {
                        name: 'Ecuador (+593)',
                        value: '593'
                    },
                    {
                        name: 'Egypt (+20)',
                        value: '20'
                    },
                    {
                        name: 'El Salvador (+503)',
                        value: '503'
                    },
                    {
                        name: 'Equatorial Guinea (+240)',
                        value: '240'
                    },
                    {
                        name: 'Eritrea (+291)',
                        value: '291'
                    },
                    {
                        name: 'Estonia (+372)',
                        value: '372'
                    },
                    {
                        name: 'Ethiopia (+251)',
                        value: '251'
                    },
                    {
                        name: 'Falkland Islands (+500)',
                        value: '500'
                    },
                    {
                        name: 'Faroe Islands (+298)',
                        value: '298'
                    },
                    {
                        name: 'Fiji (+679)',
                        value: '679'
                    },
                    {
                        name: 'Finland (+358)',
                        value: '358'
                    },
                    {
                        name: 'France (+33)',
                        value: '33'
                    },
                    {
                        name: 'French Guiana (+594)',
                        value: '594'
                    },
                    {
                        name: 'French Polynesia (+689)',
                        value: '689'
                    },
                    {
                        name: 'Gabon (+241)',
                        value: '241'
                    },
                    {
                        name: 'Gambia (+220)',
                        value: '220'
                    },
                    {
                        name: 'Georgia (+7880)',
                        value: '7880'
                    },
                    {
                        name: 'Germany (+49)',
                        value: '49'
                    },
                    {
                        name: 'Ghana (+233)',
                        value: '233'
                    },
                    {
                        name: 'Gibraltar (+350)',
                        value: '350'
                    },
                    {
                        name: 'Greece (+30)',
                        value: '30'
                    },
                    {
                        name: 'Greenland (+299)',
                        value: '299'
                    },
                    {
                        name: 'Grenada (+1473)',
                        value: '1473'
                    },
                    {
                        name: 'Guadeloupe (+590)',
                        value: '590'
                    },
                    {
                        name: 'Guam (+671)',
                        value: '671'
                    },
                    {
                        name: 'Guatemala (+502)',
                        value: '502'
                    },
                    {
                        name: 'Guinea (+224)',
                        value: '224'
                    },
                    {
                        name: 'Guinea - Bissau (+245)',
                        value: '245'
                    },
                    {
                        name: 'Guyana (+592)',
                        value: '592'
                    },
                    {
                        name: 'Haiti (+509)',
                        value: '509'
                    },
                    {
                        name: 'Honduras (+504)',
                        value: '504'
                    },
                    {
                        name: 'Hong Kong (+852)',
                        value: '852'
                    },
                    {
                        name: 'Hungary (+36)',
                        value: '36'
                    },
                    {
                        name: 'Iceland (+354)',
                        value: '354'
                    },
                    {
                        name: 'India (+91)',
                        value: '91'
                    },
                    {
                        name: 'Indonesia (+62)',
                        value: '62'
                    },
                    {
                        name: 'Iran (+98)',
                        value: '98'
                    },
                    {
                        name: 'Iraq (+964)',
                        value: '964'
                    },
                    {
                        name: 'Ireland (+353)',
                        value: '353'
                    },
                    {
                        name: 'Israel (+972)',
                        value: '972'
                    },
                    {
                        name: 'Italy (+39)',
                        value: '39'
                    },
                    {
                        name: 'Jamaica (+1876)',
                        value: '1876'
                    },
                    {
                        name: 'Japan (+81)',
                        value: '81'
                    },
                    {
                        name: 'Jordan (+962)',
                        value: '962'
                    },
                    {
                        name: 'Kazakhstan (+7)',
                        value: '7'
                    },
                    {
                        name: 'Kenya (+254)',
                        value: '254'
                    },
                    {
                        name: 'Kiribati (+686)',
                        value: '686'
                    },
                    {
                        name: 'Korea North (+850)',
                        value: '850'
                    },
                    {
                        name: 'Korea South (+82)',
                        value: '82'
                    },
                    {
                        name: 'Kuwait (+965)',
                        value: '965'
                    },
                    {
                        name: 'Kyrgyzstan (+996)',
                        value: '996'
                    },
                    {
                        name: 'Laos (+856)',
                        value: '856'
                    },
                    {
                        name: 'Latvia (+371)',
                        value: '371'
                    },
                    {
                        name: 'Lebanon (+961)',
                        value: '961'
                    },
                    {
                        name: 'Lesotho (+266)',
                        value: '266'
                    },
                    {
                        name: 'Liberia (+231)',
                        value: '231'
                    },
                    {
                        name: 'Libya (+218)',
                        value: '218'
                    },
                    {
                        name: 'Liechtenstein (+417)',
                        value: '417'
                    },
                    {
                        name: 'Lithuania (+370)',
                        value: '370'
                    },
                    {
                        name: 'Luxembourg (+352)',
                        value: '352'
                    },
                    {
                        name: 'Macao (+853)',
                        value: '853'
                    },
                    {
                        name: 'Macedonia (+389)',
                        value: '389'
                    },
                    {
                        name: 'Madagascar (+261)',
                        value: '261'
                    },
                    {
                        name: 'Malawi (+265)',
                        value: '265'
                    },
                    {
                        name: 'Malaysia (+60)',
                        value: '60'
                    },
                    {
                        name: 'Maldives (+960)',
                        value: '960'
                    },
                    {
                        name: 'Mali (+223)',
                        value: '223'
                    },
                    {
                        name: 'Malta (+356)',
                        value: '356'
                    },
                    {
                        name: 'Marshall Islands (+692)',
                        value: '692'
                    },
                    {
                        name: 'Martinique (+596)',
                        value: '596'
                    },
                    {
                        name: 'Mauritania (+222)',
                        value: '222'
                    },
                    {
                        name: 'Mayotte (+269)',
                        value: '269'
                    },
                    {
                        name: 'Mexico (+52)',
                        value: '52'
                    },
                    {
                        name: 'Micronesia (+691)',
                        value: '691'
                    },
                    {
                        name: 'Moldova (+373)',
                        value: '373'
                    },
                    {
                        name: 'Monaco (+377)',
                        value: '377'
                    },
                    {
                        name: 'Mongolia (+976)',
                        value: '976'
                    },
                    {
                        name: 'Montserrat (+1664)',
                        value: '1664'
                    },
                    {
                        name: 'Morocco (+212)',
                        value: '212'
                    },
                    {
                        name: 'Mozambique (+258)',
                        value: '258'
                    },
                    {
                        name: 'Myanmar (+95)',
                        value: '95'
                    },
                    {
                        name: 'Namibia (+264)',
                        value: '264'
                    },
                    {
                        name: 'Nauru (+674)',
                        value: '674'
                    },
                    {
                        name: 'Nepal (+977)',
                        value: '977'
                    },
                    {
                        name: 'Netherlands (+31)',
                        value: '31'
                    },
                    {
                        name: 'New Caledonia (+687)',
                        value: '687'
                    },
                    {
                        name: 'New Zealand (+64)',
                        value: '64'
                    },
                    {
                        name: 'Nicaragua (+505)',
                        value: '505'
                    },
                    {
                        name: 'Niger (+227)',
                        value: '227'
                    },
                    {
                        name: 'Nigeria (+234)',
                        value: '234'
                    },
                    {
                        name: 'Niue (+683)',
                        value: '683'
                    },
                    {
                        name: 'Norfolk Islands (+672)',
                        value: '672'
                    },
                    {
                        name: 'Northern Marianas (+670)',
                        value: '670'
                    },
                    {
                        name: 'Norway (+47)',
                        value: '47'
                    },
                    {
                        name: 'Oman (+968)',
                        value: '968'
                    },
                    {
                        name: 'Palau (+680)',
                        value: '680'
                    },
                    {
                        name: 'Panama (+507)',
                        value: '507'
                    },
                    {
                        name: 'Papua New Guinea (+675)',
                        value: '675'
                    },
                    {
                        name: 'Paraguay (+595)',
                        value: '595'
                    },
                    {
                        name: 'Peru (+51)',
                        value: '51'
                    },
                    {
                        name: 'Philippines (+63)',
                        value: '63'
                    },
                    {
                        name: 'Poland (+48)',
                        value: '48'
                    },
                    {
                        name: 'Portugal (+351)',
                        value: '351'
                    },
                    {
                        name: 'Puerto Rico (+1787)',
                        value: '1787'
                    },
                    {
                        name: 'Qatar (+974)',
                        value: '974'
                    },
                    {
                        name: 'Reunion (+262)',
                        value: '262'
                    },
                    {
                        name: 'Romania (+40)',
                        value: '40'
                    },
                    {
                        name: 'Russia (+7)',
                        value: '7'
                    },
                    {
                        name: 'Rwanda (+250)',
                        value: '250'
                    },
                    {
                        name: 'San Marino (+378)',
                        value: '378'
                    },
                    {
                        name: 'Sao Tome & Principe (+239)',
                        value: '239'
                    },
                    {
                        name: 'Saudi Arabia (+966)',
                        value: '966'
                    },
                    {
                        name: 'Senegal (+221)',
                        value: '221'
                    },
                    {
                        name: 'Serbia (+381)',
                        value: '381'
                    },
                    {
                        name: 'Seychelles (+248)',
                        value: '248'
                    },
                    {
                        name: 'Sierra Leone (+232)',
                        value: '232'
                    },
                    {
                        name: 'Singapore (+65)',
                        value: '65'
                    },
                    {
                        name: 'Slovak Republic (+421)',
                        value: '421'
                    },
                    {
                        name: 'Slovenia (+386)',
                        value: '386'
                    },
                    {
                        name: 'Solomon Islands (+677)',
                        value: '677'
                    },
                    {
                        name: 'Somalia (+252)',
                        value: '252'
                    },
                    {
                        name: 'South Africa (+27)',
                        value: '27'
                    },
                    {
                        name: 'Spain (+34)',
                        value: '34'
                    },
                    {
                        name: 'Sri Lanka (+94)',
                        value: '94'
                    },
                    {
                        name: 'St. Helena (+290)',
                        value: '290'
                    },
                    {
                        name: 'St. Kitts (+1869)',
                        value: '1869'
                    },
                    {
                        name: 'St. Lucia (+1758)',
                        value: '1758'
                    },
                    {
                        name: 'Sudan (+249)',
                        value: '249'
                    },
                    {
                        name: 'Suriname (+597)',
                        value: '597'
                    },
                    {
                        name: 'Swaziland (+268)',
                        value: '268'
                    },
                    {
                        name: 'Sweden (+46)',
                        value: '46'
                    },
                    {
                        name: 'Switzerland (+41)',
                        value: '41'
                    },
                    {
                        name: 'Syria (+963)',
                        value: '963'
                    },
                    {
                        name: 'Taiwan (+886)',
                        value: '886'
                    },
                    {
                        name: 'Tajikstan (+7)',
                        value: '7'
                    },
                    {
                        name: 'Thailand (+66)',
                        value: '66'
                    },
                    {
                        name: 'Togo (+228)',
                        value: '228'
                    },
                    {
                        name: 'Tonga (+676)',
                        value: '676'
                    },
                    {
                        name: 'Trinidad & Tobago (+1868)',
                        value: '1868'
                    },
                    {
                        name: 'Tunisia (+216)',
                        value: '216'
                    },
                    {
                        name: 'Turkey (+90)',
                        value: '90'
                    },
                    {
                        name: 'Turkmenistan (+7)',
                        value: '7'
                    },
                    {
                        name: 'Turkmenistan (+993)',
                        value: '993'
                    },
                    {
                        name: 'Turks & Caicos Islands (+1649)',
                        value: '1649'
                    },
                    {
                        name: 'Tuvalu (+688)',
                        value: '688'
                    },
                    {
                        name: 'Uganda (+256)',
                        value: '256'
                    },
                    {
                        name: 'Ukraine (+380)',
                        value: '380'
                    },
                    {
                        name: 'United Arab Emirates (+971)',
                        value: '971'
                    },
                    {
                        name: 'Uruguay (+598)',
                        value: '598'
                    },
                    {
                        name: 'Uzbekistan (+7)',
                        value: '7'
                    },
                    {
                        name: 'Vanuatu (+678)',
                        value: '678'
                    },
                    {
                        name: 'Vatican City (+379)',
                        value: '379'
                    },
                    {
                        name: 'Venezuela (+58)',
                        value: '58'
                    },
                    {
                        name: 'Vietnam (+84)',
                        value: '84'
                    },
                    {
                        name: 'Virgin Islands - British (+1284)',
                        value: '84'
                    },
                    {
                        name: 'Virgin Islands - US (+1340)',
                        value: '84'
                    },
                    {
                        name: 'Wallis & Futuna (+681)',
                        value: '681'
                    },
                    {
                        name: 'Yemen (North)(+969)',
                        value: '969'
                    },
                    {
                        name: 'Yemen (South)(+967)',
                        value: '967'
                    },
                    {
                        name: 'Zambia (+260)',
                        value: '260'
                    },
                    {
                        name: 'Zimbabwe (+263)',
                        value: '263'
                    },
                ]
            }
        }
    }
</script>

<style scoped>

</style>
